import { defineComponent as d, computed as n, createElementBlock as f, createCommentVNode as p, unref as s, openBlock as g, createVNode as C } from "vue";
import { useWorkspace as S, useActiveEntities as h } from "@scalar/api-client/store";
import { getSlugUid as _ } from "@scalar/oas-utils/transforms";
import { getCurrentIndex as k } from "./get-current-index.js";
import { useNavState as I } from "../../../hooks/useNavState.js";
import O from "./TraversedEntry.vue.js";
import { useSidebar as E } from "../../../features/sidebar/hooks/useSidebar.js";
const N = { key: 0 }, T = /* @__PURE__ */ d({
  __name: "TraversedEntryContainer",
  props: {
    document: {},
    config: {},
    clientOptions: {},
    store: {}
  },
  setup(i) {
    const { collections: l, servers: c } = S(), { activeCollection: u } = h(), t = n(() => {
      var e;
      if ((e = i.config) != null && e.slug) {
        const r = l[_(i.config.slug)];
        if (r)
          return r;
      }
      return u.value;
    }), a = n(() => {
      if (t.value) {
        if (t.value.selectedServerUid) {
          const e = c[t.value.selectedServerUid];
          if (e)
            return e;
        }
        return c[t.value.servers[0]];
      }
    }), { items: o } = E(), { hash: v } = I(), m = n(
      () => k(v.value, o.value.entries)
    );
    return (e, r) => s(o).entries.length && t.value ? (g(), f("div", N, [
      C(O, {
        activeCollection: t.value,
        activeServer: a.value,
        clientOptions: e.clientOptions,
        config: e.config,
        document: e.document,
        entries: s(o).entries,
        rootIndex: m.value,
        store: e.store
      }, null, 8, ["activeCollection", "activeServer", "clientOptions", "config", "document", "entries", "rootIndex", "store"])
    ])) : p("", !0);
  }
});
export {
  T as default
};
